import { ColorProps } from '@chakra-ui/react';
import { Icon, IconName } from '../../../medias';

export function ToastIcon({
  icon,
  color,
  withIcon = true
}: {
  icon: IconName;
  color: ColorProps['color'];
  withIcon?: boolean;
}): JSX.Element | null {
  if (!withIcon) {
    return null;
  }
  return (
    <Icon
      data-testid={`icon-${icon}`}
      mr="space_unit.x1 "
      w="22px"
      h="22px"
      name={icon}
      color={color}
    />
  );
}
